import React, { useEffect, useState } from "react";
import AdminAppBody from "../../../../components/admin/AdminAppBody";
import useApiCallHooks from "../../../../hooks/useApiCallHooks";

const Mentor = () => {
  const [responce, loading, error, callAPI, statusCode] = useApiCallHooks();
  const [data, setData] = useState([]);

  // API call on mount
  useEffect(() => {
    callAPI("get", "student/student-assign-mentor-list");
  }, []);

  // Set data when response comes
  useEffect(() => {
    if (responce && responce.data) {
      setData(responce.data);
    }
  }, [responce]);

  return (
    <AdminAppBody
    loading={loading}
      content={
        <div className="container py-4">
          <div className="bg-white rounded shadow-sm p-4">
            <h4 className="fw-bold mb-4">Assign Mentors</h4>
            <div className="table-responsive">
              <table className="table table-bordered align-middle">
                <thead className="table-primary">
                  <tr>
                    <th scope="col">Sr.No</th>
                    <th scope="col">Name</th>
                    <th scope="col">Email</th>
                    <th scope="col">Mobile</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((mentor, index) => (
                    <tr key={mentor.id}>
                      <td>{index + 1}</td>
                      <td className="d-flex align-items-center gap-2">
                        {/* <img
                          src="https://via.placeholder.com/35"
                          alt="user"
                          style={{ width: "35px", height: "35px" }}
                          className="rounded-circle border"
                        /> */}
                        <span>{mentor.first_name}</span>
                        <span>{mentor.last_name}</span>

                      </td>
                      <td>{mentor.email}</td>
                      <td>{mentor.mobile_no}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      }
    />
  );
};

export default Mentor;
